<template>
  <div class="container">
    <!-- content row -->
    <div class="row align-items-stretch">
      <!-- APP STATUS COLUMN -->
      <div
        id="app-status-column"
        class="col-lg-4 order-last order-lg-first pl-5 box-shadow"
      >
        <!-- nested elements container -->
        <div class="container-fluid">
          <div class="row">
            <!-- nested progress meter -->

            <div class="col-lg-12 col-md-6 col-sm-6 col-xs-12 pb-3">
              <h5>
                {{ this.message(this.$appdata.messages, "progress").label }}
              </h5>
              <Progress
                :completedSteps="completedSteps"
                :totalSteps="totalSteps"
              />
            </div>
            <!-- end nested progress meter -->

            <!-- nested guide -->
            <div class="col-lg-12 col-md-6 col-sm-6 col-xs-12">
              <h5>{{ this.message(this.$appdata.messages, "guide").label }}</h5>
              <blockquote class="speech-bubble">
                <div
                  v-html="
                    this.message(this.$appdata.messages, 'not_qualified').msg
                  "
                ></div>
              </blockquote>
              <p>
                <img
                  class="avatar rounded-circle shadow"
                  src="assets/images/avataaars.png"
                />
              </p>
            </div>
            <!-- end nested guide -->
          </div>
          <!-- end nested elements row -->
        </div>
        <!-- end nested elements container -->
      </div>
      <!-- end app status column -->

      <!-- APP CONTENT COLUMN -->
      <div
        id="app-content-column"
        class="col-lg-8 col-md-12 order-first order-lg-lasts d-flex align-items-stretch"
      >
        <div class="box-shadow">
          <!-- CONTENT HERE -->
          <div id="content-box" v-html="content"></div>
          <div id="button-wrapper" class="pb-5">
            <b-row align-h="center">
              <b-button
                size="lg"
                variant="primary"
                @click="goto($appdata.urls.refer_friend)"
                squared
                >{{ this.$appdata.buttons.refer_friend }}
              </b-button>
            </b-row>
            <b-row align-h="center">
              <div class="col-lg-8 col-md-12 text-center pt-5">
                <a :href="$appdata.urls.homepage">{{
                  $appdata.buttons.homepage
                }}</a>
              </div>
            </b-row>
          </div>
        </div>
        <!-- end content wrapper -->
      </div>
      <!-- end app content column -->
    </div>
    <!-- end content row -->
  </div>
  <!-- end app-wrapper -->
</template>
<script>
import { messaging } from "@/mixins/messaging.js";
import { navigation } from "@/mixins/navigation.js";
export default {
  mixins: [messaging, navigation],
  components: {
    Progress: () => import("@/components/Progress.vue"),
  },
  data() {
    return {
      completedSteps: 5,
      totalSteps: 5,
      estimate: null,
    };
  },
  computed: {
    content: function () {
      return this.message(this.$appdata.messages, "not_qualified").label;
    },
  },
  mounted: function () {
    if (this.$cookie.get(this.$appdata.ck_name)) {
      var c = this.$cookie.get(this.$appdata.ck_name);
      c = atob(c);
      c = JSON.parse(c);
      for (let item in c) {
        this[item] = c[item];
      }
      // Delete the cookie.
      if (this.$appdata.debug != 1 && this.$appdata.debug != 0) {
        this.$cookie.delete(this.$appdata.ck_name);
      }
    } else {
      if (this.$appdata.debug != 1 && this.$appdata.debug != 0) {
        this.$router.push({ name: "index" });
      }
    }
  },
};
</script>
<style lang="scss"></style>
